<template>
  <div class="calico-field-page">
    <div class="calico-field-container">
      <div class="calico-field-row">
        <CalicoField
          v-model="text1"
          placeholder="Placeholder text..."
        />
        <CalicoField
          v-model="text2"
          placeholder="Placeholder text..."
          error
        />
        <CalicoField
          v-model="text3"
          placeholder="Placeholder text..."
          disabled
        />
      </div>
      <div class="calico-field-row">
        <CalicoField
          v-model="text4"
          symbol="$"
          :only-numbers="true"
        />
        <CalicoField
          v-model="text5"
          symbol="$"
          error
          :only-numbers="true"
        />
        <CalicoField
          v-model="text6"
          symbol="$"
          disabled
        />
      </div>
      <div class="calico-field-row">
        <CalicoField
          v-model="text7"
          symbol="%"
          :only-numbers="true"
        />
        <CalicoField
          v-model="text8"
          symbol="%"
          error
          :only-numbers="true"
        />
        <CalicoField
          v-model="text9"
          symbol="%"
          disabled
        />
      </div>
      <div class="calico-field-row">
        <CalicoField
          v-model="text10"
          icon="arrow-up-circle-fill"
        />
        <CalicoField
          v-model="text12"
          icon="arrow-up-circle-fill"
          error
        />
        <CalicoField
          v-model="text6"
          icon="arrow-up-circle-fill"
          disabled
        />
      </div>
    </div>
  </div>
</template>

<script lang="js">
import CalicoField from '@/components/calico/field/index.vue'
export default {
  name: 'CalicoFieldPage',
  components: {
    CalicoField
  },
  data () {
    return {
      text1: '',
      text2: '',
      text3: '',
      text4: '',
      text5: '',
      text6: '',
      text7: '',
      text8: '',
      text9: '',
      text10: '',
      text11: '',
      text12: ''
    }
  },
  watch: {
    text1 (value) {
      console.log(value)
    },
    text2 (value) {
      console.log(value)
    },
    text3 (value) {
      console.log(value)
    },
    text4 (value) {
      console.log(value)
    },
    text5 (value) {
      console.log(value)
    },
    text6 (value) {
      console.log(value)
    },
    text7 (value) {
      console.log(value)
    },
    text8 (value) {
      console.log(value)
    },
    text9 (value) {
      console.log(value)
    },
    text10 (value) {
      console.log(value)
    },
    text11 (value) {
      console.log(value)
    },
    text12 (value) {
      console.log(value)
    }
  }
}
</script>
<style lang="scss">
.calico-field-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-field-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 100%;
    .calico-field-row {
      @include inline-space($space-large);
      @include inset-space($space-large);
      width: 100%;
    }
  }
}
</style>
